import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import fileDownload from 'js-file-download';
import { EXPORT_BOS_API_REQUEST_URL } from '../../../common/apiConfig';
import {
  MANAGE_SUBS_EXPORT_GROUPS_DATA_BEGIN,
  MANAGE_SUBS_EXPORT_GROUPS_DATA_SUCCESS,
  MANAGE_SUBS_EXPORT_GROUPS_DATA_FAILURE,
  MANAGE_SUBS_EXPORT_GROUPS_DATA_DISMISS_ERROR,
} from './constants';

export function exportGroupsData(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_EXPORT_GROUPS_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios({
        url: `${EXPORT_BOS_API_REQUEST_URL}/customGroup/exportManageGroups`,
        method: 'post',
        data: args,
        responseType: 'blob',
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_EXPORT_GROUPS_DATA_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_EXPORT_GROUPS_DATA_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissExportGroupsDataError() {
  return {
    type: MANAGE_SUBS_EXPORT_GROUPS_DATA_DISMISS_ERROR,
  };
}

export function useExportGroupsData() {
  const dispatch = useDispatch();

  const { exportGroupsDataPending, exportGroupsDataError } = useSelector(
    state => ({
      exportGroupsDataPending: state.manageSubs.exportGroupsDataPending,
      exportGroupsDataError: state.manageSubs.exportGroupsDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(exportGroupsData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissExportGroupsDataError());
  }, [dispatch]);

  return {
    exportGroupsData: boundAction,
    exportGroupsDataPending,
    exportGroupsDataError,
    dismissExportGroupsDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_EXPORT_GROUPS_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        exportGroupsDataPending: true,
        exportGroupsDataError: null,
      };

    case MANAGE_SUBS_EXPORT_GROUPS_DATA_SUCCESS:
      // The request is success
      fileDownload(action.data, "Customer Group Reports.xlsx");
      return {
        ...state,
        exportGroupsDataPending: false,
        exportGroupsDataError: null,
      };

    case MANAGE_SUBS_EXPORT_GROUPS_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        exportGroupsDataPending: false,
        exportGroupsDataError: action.data.error,
      };

    case MANAGE_SUBS_EXPORT_GROUPS_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        exportGroupsDataError: null,
      };

    default:
      return state;
  }
}
